import { sectionMargin } from 'common/components/page-section';
import { css } from 'linaria';

export const productQualityDocumentsWrapper = css`
  margin-top: var(--space-500);

  ul {
    padding: 0;
  }
`;

export const fileTextIconWrapper = css`
  padding: var(--space-100);
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-minor);
`;

export const listItem = css`
  padding-left: var(--space-300);

  @media (--from-tablet) {
    padding-left: var(--space-100);
  }

  li {
    column-gap: var(--space-150);
  }
`;

export const divider = css`
  margin: ${sectionMargin}px 0;

  @media (--only-mobile) {
    border: none !important;
    margin: ${sectionMargin}px 0 0;
  }
`;
